import { ProcoColumn } from './prococolumn';
import { ProcoList } from './procolist';

export class CompareList extends ProcoList {
  columns = new Array<ProcoColumn>();
}